import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { SharedModule } from "../shared/shared.module";
import { SettingsComponent } from "./settings.component";
import { EmployeeSettingsComponent } from "../employee-settings/employee-settings.component";
import { SettingsEffects } from "./settings.effects";
import { SettingsService } from "./settings.service";
import { settingsReducer } from "./settings.reducer";
import { CompanyComponent } from "../company/company.component";
import { AdvancedSettingsComponent } from "../advanced-settings/advanced-settings.component";
import { BillingComponent } from "../billing/billing.component";
import { BillingSettingsComponent } from "../billing/settings/billing-settings.component";
import { BillingSuccessComponent } from "../billing/success/success.component";
import { BillingCancelComponent } from "../billing/cancel/cancel.component";
import { ApiSettingsComponent } from "../api-settings/api-settings.component";
import { CreateTokenDialogComponent } from "../api-settings/create-token/create-token-dialog.component";
import { IntegrationSettingsComponent } from "../integration-settings/integration-settings.component";
import { SyncSuccessDialogComponent } from "../integration-settings/sync-success-dialog/sync-success-dialog.component";
import { GoogleIntegrationComponent } from "../integration-settings/google-integration/google-integration.component";
import { MicrosoftIntegrationComponent } from "../integration-settings/microsoft-integration/microsoft-integration.component";
import { CalamariIntegrationComponent } from "../integration-settings/calamari-integration/calamari-integration.component";
import { FreemiumPlanDialogComponent } from "../billing/settings/freemium-plan-dialog/freemium-plan-dialog.component";
import { YearlyLicensePurchaseDialogComponent } from "../billing/settings/yearly-license-purchase-dialog/yearly-license-purchase-dialog.component";
import { MonthlyLicensePurchaseDialogComponent } from "../billing/settings/monthly-license-purchase-dialog/monthly-license-purchase-dialog.component";
import { UpfrontLicensePurchaseDialogComponent } from "../billing/settings/upfront-license-purchase-dialog/upfront-license-purchase-dialog.component";
import { UpfrontLicenseChangeDialogComponent } from "../billing/settings/upfront-license-change-dialog/upfront-license-change-dialog.component";
import { SubscriptionInfoCardComponent } from "../billing/settings/subscription-info-card/subscription-info-card.component";
import { FormsModule } from "@angular/forms";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { RouterModule } from "@angular/router";
import { SyncProgressModule } from "../sync-progress/sync-progress.module";
import { EmployeesModule } from "../employees/employees.module";
import { BranchSettingsComponent } from "../branch-settings/branch-settings.component";
import { BranchEditDialogComponent } from "../branch-settings/branch-edit-dialog/branch-edit-dialog.component";
import { BranchVariableFormDialogComponent } from "../branch-settings/branch-variable-form-dialog/branch-variable-form-dialog.component";
import { QRCodeComponent } from "angularx-qrcode";

@NgModule({
  declarations: [
    CompanyComponent,
    EmployeeSettingsComponent,
    BranchSettingsComponent,
    BranchEditDialogComponent,
    BranchVariableFormDialogComponent,
    AdvancedSettingsComponent,
    SettingsComponent,
    BillingComponent,
    BillingSuccessComponent,
    BillingCancelComponent,
    IntegrationSettingsComponent,
    SyncSuccessDialogComponent,
    GoogleIntegrationComponent,
    MicrosoftIntegrationComponent,
    CalamariIntegrationComponent,
    FreemiumPlanDialogComponent,
    YearlyLicensePurchaseDialogComponent,
    MonthlyLicensePurchaseDialogComponent,
    UpfrontLicensePurchaseDialogComponent,
    UpfrontLicenseChangeDialogComponent,
    SubscriptionInfoCardComponent,
    BillingSettingsComponent,
    ApiSettingsComponent,
    CreateTokenDialogComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    StoreModule.forFeature("settings", settingsReducer),
    EffectsModule.forFeature([SettingsEffects]),
    RouterModule,
    FormsModule,
    MatSlideToggleModule,
    SyncProgressModule,
    EmployeesModule,
    QRCodeComponent,
  ],
  providers: [SettingsService],
})
export class SettingsModule {}
